module.exports = __webpack_public_path__ + "img/dialog-idCardBack.ef2f1249.png";